<template>
  <nav v-if="items.length" class="mb-10 flex flex-col gap-y-4">
    <UiLink
      v-for="(item, i) in items"
      :key="item.id"
      :to="`/catalog/${item.slug}`"
      class="title text-lg uppercase leading-none text-slate hover:text-blue"
      :class="{ '!text-blue': activeSlug === item.slug }"
    >
      {{ i === 0 ? $t('all_products') : item.name }}
    </UiLink>
  </nav>
</template>

<script setup lang="ts">
interface Props {
  items?: any[];
  activeSlug?: string;
}

withDefaults(defineProps<Props>(), {
  items: () => [],
  activeSlug: '',
});
</script>
